import { Component, Inject, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { HomeController } from '@shared/src/controllers/home/home.controller';
import { SocketController } from '@shared/src/controllers/socket/socket.controller';
import { HString } from '@shared/src/datatypes/HString';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { BookingController } from '@shared/src/controllers/booking/booking.controller';
import { RouteCardItemDto } from '@shared/src/dtos/route/RouteCardItemDto';
import { HLong } from '@shared/src/datatypes/HLong';
import { MaintenanceSearchByTextDto } from '@shared/src/controllers/maintenance/_base/MaintenanceSearchByTextDtos';
import { ActionsStripDto } from '@shared/src/dtos/maintenance/action/ActionsStripDto';
import { ActionDto } from '@shared/src/dtos/maintenance/action/actionDto';
import { MultiSelectDto } from '@shared/src/dtos/booking/MultiSelectDto';
import { SharedActiveBookings } from '../../shared.active.bookings';
import { AddressAmbitSelectorDto } from '@shared/src/public-api';
import { BookingSearchRoutesWithBookingResultDto } from '@shared/src/controllers/booking/BookingSearchRoutesWithBookingResultDto';

@Component({
	selector: 'shared-active-bookings-item-addroute',
	templateUrl: './shared.active.bookings.item.addroute.html',
	styleUrls: ['./shared.active.bookings.item.addroute.scss']
})
export class SharedActiveBookingsItemAddRoute implements OnInit {

	searchTextUpdate = new Subject<string>();

	public useIonic: boolean = false;
	constructor(public bookingController: BookingController,
		@Inject('HomeController') protected homeController: HomeController,
		protected socketController: SocketController) {

		// Debounce search.
		this.searchTextUpdate.pipe(
			debounceTime(HomeController.DEFAULT_BOUNCE_BUTTON_TIME),
			distinctUntilChanged())
			.subscribe(value => {
				//Refresquem si treiem el searchText
				this.loadData(false);
				if (!HString.isNullOrNullString(this.searchText) && this.searchText.length > 2) {
					//Si tenim un mínim de 3 digits comprovem si estem buscant una ruta que ja esta a un altre booking
					this.routeItemsWithBookingAndExcludedBookingId();
				}
			});

		this.socketController.notificationReloadHome$.subscribe(e => {
			this.loadData(false);
		});

		if (homeController.useIonic)
			this.useIonic = homeController.useIonic();

	}

	@Input() public readonly: boolean;

	public searchText: string = "";
	public filterMetadata: any = {};

	public routes: Array<RouteCardItemDto> = [];
	public selectedRoutes: Array<number> = [];

	public showingSelectedRoutes = false;
	public routesCount: number = 0;
	public actions: ActionsStripDto;

	public confirmRoutesActions: ActionsStripDto;

	public sliceCount: number = SharedActiveBookings.SLICECOUNTINITIAL;

	@Output() finishAddRoutes = new EventEmitter<boolean>();

	ngOnInit(): void {

		this.loadActions();
	}

	public _bookingId: number;
	@Input()
	public get bookingId(): number {
		return this._bookingId;
	}
	public set bookingId(value: number) {
		if (this._bookingId === value)
			return;
		this._bookingId = value;

		this.addressAmbit = AddressAmbitSelectorDto.buildActiveRoutes();
	}


	public _addressAmbit: AddressAmbitSelectorDto;
	public get addressAmbit(): AddressAmbitSelectorDto {
		return this._addressAmbit;
	}
	public set addressAmbit(value: AddressAmbitSelectorDto) {
		if (this._addressAmbit === value)
			return;
		this._addressAmbit = value;
	}

	public onChangeAddressAmbitSelector($event: AddressAmbitSelectorDto) {
		this._addressAmbit = $event;
		if ($event != null) {
			this.filter.ambitId = $event.ambitId;
			this.filter.addressId = $event.addressId;
		} else {
			this.filter.ambitId = 0;
			this.filter.addressId = 0;
		}
		this.loadData(true);
	}

	ngAfterViewChecked(): void {
	}

	public filter: MaintenanceSearchByTextDto = new MaintenanceSearchByTextDto();
	loadData(busy: boolean) {

		//Si tenim ruta seleccionada, no te sentit fer cerca total
		if (HLong.isNullOrNullLong(this.bookingId))
			return;

		this.routes = [];
		this.routesCount = 0;
		this.selectedRoutes = [];
		this.showingSelectedRoutes = false;
		this.filter.searchtext = this.searchText;

		this.bookingSearchRoutesWithBooking = null;
		this.bookingController.getPendingRouteItems(this.filter, busy).subscribe(e => {
			this.routes = e;
			this.routesCount = e.length;
			this.showingSelectedRoutes = false;
		});

	}

	public bookingSearchRoutesWithBooking: BookingSearchRoutesWithBookingResultDto;
	/**
	 * Busquem si hi han rutes que ja estan amb un booking que no es el seleccionat i te conicidencies amb el searchText
	 */
	routeItemsWithBookingAndExcludedBookingId() {
		if (HLong.isNullOrNullLong(this.bookingId))
			return;

		this.bookingSearchRoutesWithBooking = null;
		if (!HString.isNullOrNullString(this.searchText)) {
			this.filter.searchtext = this.searchText;
			this.bookingController.existsRoutesWithBookingAndExcludedBookingId(this.bookingId, this.filter, false).subscribe(e => {
				this.bookingSearchRoutesWithBooking = e;
				console.log(e.message);
			});
		}
	}

	getSelectedRoutesCount() {
		let x = this.getSelectedRoutes();
		if (x)
			return x.length;
		return 0;
	}
	getSelectedRoutes() {
		return this.routes.filter(r => this.selectedRoutes.includes(r.routeId));
	}

	onSelectRoute(item: RouteCardItemDto) {
		if (this.selectedRoutes.includes(item.routeId))
			this.selectedRoutes.splice(this.selectedRoutes.indexOf(item.routeId), 1);
		else
			this.selectedRoutes.push(item.routeId);

		this.loadActions();
	}

	public loadActions() {
		this.actions = new ActionsStripDto();
		this.actions.add(ActionDto.buildAdd("SELECTALL", "BOOKINGPAGE.SELECTALL.CAPTION", null, null, 0, -1, 1, null));
		this.actions.add(ActionDto.build("DESELECTALL", "BOOKINGPAGE.DESELECTALL.CAPTION", null, null, 1, -1, 1, null));

		let showNext: boolean = this.selectedRoutes && this.selectedRoutes.length > 0;

		if (showNext)
			this.actions.add(ActionDto.buildAdd("NEXT", "MAINTENANCE.NEXT", null, "fa-arrow-right", 2, 0, 1, null));
		else
			this.actions.add(ActionDto.build("NEXTO", "MAINTENANCE.NEXT", null, "fa-arrow-right", 2, 0, 1, null));

		this.confirmRoutesActions = new ActionsStripDto();
		this.confirmRoutesActions.add(ActionDto.build("CANCEL", "BOOKINGPAGE.CANCEL.CAPTION", null, null, 0, -1, 1, null));
		this.confirmRoutesActions.add(ActionDto.buildAdd("CONFIRM", "BOOKINGPAGE.CONFIRM.CAPTION", null, null, 1, -1, 1, null));
	}


	public onClickAction(item: ActionDto) {
		if (!item)
			return;

		switch (item.actionId) {
			case "SELECTALL":

				console.log(this.filterMetadata);
				this.selectedRoutes = [];
				if (this.filterMetadata.items)
					this.selectedRoutes = this.filterMetadata.items.map((r: RouteCardItemDto) => r.routeId);

				this.loadActions();
				break;
			case "DESELECTALL":
				this.selectedRoutes = [];
				this.loadActions();
				break;
			case "NEXT":
				this.showingSelectedRoutes = true;
				break;
			case "CONFIRM":
				let msReserveDto: MultiSelectDto = MultiSelectDto.build(this.selectedRoutes);
				this.bookingController.multiReserveBooking(this.bookingId, msReserveDto).subscribe(e => {
					if (e) {
						// Buidem les dades del procés
						this.selectedRoutes = [];
						this.showingSelectedRoutes = false;
						this.finishAddRoutes.next(true);
					}
				});
				break;
			case "CANCEL":
				this.showingSelectedRoutes = false;
				break;
			default:
				break;
		}
	}

	onSliceMoreRoutes() {
		this.sliceCount = Math.min(this.sliceCount + SharedActiveBookings.SLICECOUNTMORE, this.routesCount);
	}

	pretty(value) {
		return JSON.stringify(value);
	}
}
